import {HttpClient} from "../../service/httpClient/HttpClient";

export class ProductImagesService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getProductImagesList(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `products/${id}/images`
            ).then(resolve).catch(reject)
        })
    }

    deleteProductImage(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.delete(
                `product-images/${id}`
            ).then(resolve).catch(reject)
        })
    }

    addNewProductImage(id, fileId, variantId, altText, position) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `products/${id}/images`,
                {
                    fileId,
                    variantId,
                    altText,
                    position,
                }
            ).then(resolve).catch(reject)
        })
    }

    updateProductImageEnabled(id, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `product-images/${id}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    updateProductImageMain(id, main) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `product-images/${id}/main`,
                {},
                {
                    main
                }
            ).then(resolve).catch(reject)
        })
    }

    getProductImageDetails(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `product-images/${id}/information`
            ).then(resolve).catch(reject)
        })
    }

    updateProductImageDetails(id,variantId,position,altText){
        return new Promise((resolve, reject)=>{
            this.httpClient.put(
                `product-images/${id}/information`,
                {
                    variantId,
                    position,
                    altText
                }
            ).then(resolve).catch(reject)
        })
    }


}